import { createStore, action, persist, thunk } from 'easy-peasy';
const MemzoToken = JSON.parse(localStorage.getItem('user-login-status'))

const modal = {
  isUserLogged:MemzoToken,
  
  eventDetails : [],
  handleEventDetails: action( (state, payload) => ({
    ...state,
    eventDetails : payload
  })),

  eventCollection : [],
  handleEventCollection: action( (state, payload) => ({
    ...state,
    eventCollection : [...state.eventCollection, ...payload]
  })),

  resetEventCollection: action( (state, payload) => ({
    ...state,
    eventCollection : payload
  })),
  
  purchaseCollection : [],
  handlePurchaseCollection: action( (state, payload) => ({
    ...state,
    purchaseCollection : [...state.purchaseCollection, ...payload]
  })),
  
 
  tempUser: persist([],{
    storage: sessionStorage
  }),

  handleTempUser: action( (state, payload) => ({
    ...state,
    tempUser : payload
  })),

  //user related state and actions 
  userProfile: persist([],{
    storage: localStorage
  }),
  handleUserProfile: action( (state, payload) => ({
    ...state,
    userProfile : payload
  })),

  handleUserProfileId: action( (state, payload) => ({
    ...state,
    userProfile : {...state.userProfile , user_profile_id : payload}
  })),

  addTodo: action((state, payload) => {
    state.todos.push({ text: payload, done: false });
  }),

  // cart related actions
  cart: [],
  toggleAuth: action((state, payload) => {    
    state.isUserLogged = payload
  }),

  instantCheckout: [],
  handleInstantCheckout: action( (state, payload) => ({
    ...state,
    instantCheckout : payload
  })),

  tempCart: [],
  handleTempCart: action( (state, payload) => ({
    ...state,
    tempCart : [...state.tempCart, payload]
  })),

  handleTempCartMultiple: action( (state, payload) => ({
    ...state,
    tempCart : [...state.tempCart, ...payload]
  })),

  bholaCart: [],
  
  handleBholaCart: action( (state, payload) => ({
    ...state,
    bholaCart : payload
  })),

  handleSingleLevelTempCart: action( (state, payload) => ({
    ...state,
    tempCart : payload
  })),

  resetTempUser: action( (state) => state.tempUser = []),
  
  resetInstantCheckout: action( (state, payload) => ({
    ...state,
    instantCheckout : payload
  })),
  resetTempCart: action( (state, payload) => ({
    ...state,
    tempCart : payload
  })),
};

const loadLocalStorage = JSON.parse(localStorage.getItem('[EasyPeasyStore][0]'))
const Store = createStore(
  (loadLocalStorage?.data) ? loadLocalStorage?.data || [] : modal);

export default Store;